angular.module('shbdeployer.integrations.storidge').controller('StoridgeDrivesController', [
  '$scope',
  '$state',
  'Notifications',
  'StoridgeDriveService',
  function ($scope, $state, Notifications, StoridgeDriveService) {
    $scope.state = {
      additionInProgress: [],
      actionInProgress: false,
    };

    $scope.addAction = function (drive, idx) {
      $scope.state.additionInProgress[idx] = true;
      $scope.state.actionInProgress = true;
      StoridgeDriveService.add(drive.Device, drive.Node)
        .then(function success() {
          Notifications.success('Готово', 'Диск ' + drive.Device + ' добавлен на узел ' + drive.Node);
          $state.reload();
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось добавить диск');
        })
        .finally(function final() {
          $scope.state.additionInProgress[idx] = false;
          $scope.state.actionInProgress = false;
        });
    };

    $scope.rescanAction = function () {
      StoridgeDriveService.rescan()
        .then(function sucess() {
          $state.reload();
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось пересканировать диски');
        });
    };

    function initView() {
      StoridgeDriveService.drives()
        .then(function success(data) {
          $scope.drives = data;
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось получить диски');
        });
    }

    initView();
  },
]);
